import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Message from "../components/LoadingError/Error";
import Loading from "../components/LoadingError/Loading";
import Header from "../components/Header";
import { sendOTPLogin, verifyOTPLogin } from "../Redux/Actions/userActions";
import MobileNav from "../components/MobileNav";
import {
  DEFAULT_MOBILE_LENGTH,
  DEFAULT_MOBILE_PREFIX,
} from "../Redux/Constants/GlobalConstant";

const LoginOtp = ({ location, history }) => {
  const [mobile, setMobile] = useState("");
  const [otp, setOTP] = useState("");
  const [showOTP, setShowOTP] = useState(false);
  const [showOTPSendButton, setShowOTPSendButton] = useState(true);

  const dispatch = useDispatch();
  const redirect = location.search ? location.search.split("=")[1] : "/";

  const otpData = useSelector((state) => state.otp);
  const { error, loading, otpInfo, otpVerifyInfo } = otpData;

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const [otpError, setOTPError] = useState(null);

  useEffect(() => {
    //Checking whether user is logged in or not.
    console.log("User Info", userInfo, otpVerifyInfo);
    if (otpVerifyInfo?.status === "error") {
      setOTPError(otpVerifyInfo?.message);
    }
    if (userInfo) {
      history.push(redirect);
    }
  }, [userInfo, otpVerifyInfo, history, redirect]);

  const mobileHandler = (e) => {
    setOTPError(null);
    // Ensure the mobile number starts with zero
    if (e.length > 0 && e[0] !== DEFAULT_MOBILE_PREFIX) {
      e = DEFAULT_MOBILE_PREFIX + e;
      // setOTP(e);
    }
    setMobile(e);
    if (e.length === DEFAULT_MOBILE_LENGTH) {
      if (new RegExp(`^\\d{${DEFAULT_MOBILE_LENGTH}}$`).test(e)) {
        setShowOTP(true);
      } else {
        alert("Invalid Mobile Number");
      }
    } else setShowOTP(false);
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if (mobile.length < 11) {
      setOTPError("Enter Valid Mobile");
      return false;
    }
    if (otp.length < 6) {
      setOTPError("Enter Valid OTP");
      return false;
    }
    dispatch(verifyOTPLogin(mobile, otp));
    // dispatch(login(mobile, password));
  };

  const handleOTP = () => {
    dispatch(sendOTPLogin(mobile, false));
    setShowOTPSendButton(false);
    setTimeout(() => {
      setShowOTPSendButton(true);
    }, 30000);
  };

  // const handleCreateNewAccount = (e) => {
  //   localStorage.removeItem("user_type");
  //   history.push("/register");
  //   dispatch({ type: OTP_VERIFIED_FAIL, payload: null });
  // };

  return (
    <>
      <Header />
      <MobileNav />

      <div className="container d-flex flex-column justify-content-center align-items-center login-center">
        {error ||
          (otpError && (
            <Message variant="alert-danger">{error ? error : otpError}</Message>
          ))}
        {loading && <Loading />}
        {otpInfo?.message}
        {(localStorage.getItem("user_type") === "new" || error) && (
          <div className="no-mobile-found">
            <p>
              <Link
                to={redirect ? `/register?redirect=${redirect}` : "/register"}
              >
                Click to Create <strong>New Account</strong>
              </Link>
            </p>
          </div>
        )}

        <form
          className="Login col-md-8 col-lg-4 col-11"
          onSubmit={submitHandler}
        >
          <div className="mobile-otp-button">
            <input
              type="numeric"
              pattern="[0-9]*"
              maxLength={DEFAULT_MOBILE_LENGTH}
              placeholder="Mobile"
              value={mobile}
              onChange={(e) => mobileHandler(e.target.value)}
              required
              inputMode="numeric"
              minLength={DEFAULT_MOBILE_LENGTH}
            />
            {showOTP && (
              <button
                type="button"
                onClick={(e) => handleOTP()}
                disabled={!showOTPSendButton}
              >
                {!otpInfo && "Send OTP"}
                {otpInfo && "Send Again"}
              </button>
            )}
          </div>

          {showOTP && (
            <input
              type="text"
              inputMode="numeric"
              placeholder="OTP"
              value={otp}
              onChange={(e) =>
                setOTP(e.target.value.replace(/[^0-9]/g, "").slice(0, 6))
              }
              required
              maxLength={6}
              pattern="[0-9]*"
            />
          )}
          <button type="submit">Verify & Login</button>
          <p>
            {/* <Link className="Login-a" to={`/login-otp`}>
              Login Using Password
            </Link> */}
          </p>
          <p>
            <Link
              to={redirect ? `/register?redirect=${redirect}` : "/register"}
            >
              Click to Create <strong>New Account</strong>
            </Link>
          </p>
          <p className="privacy-policy-links">
            By continuing, you agree to our{" "}
            <Link to="/term-condition"> Terms of service </Link> &{" "}
            <Link to="/policy">Privacy policy </Link>
          </p>
        </form>
      </div>
    </>
  );
};

export default LoginOtp;
